/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpgradeAssistantIdentityRequestBody = {
  /**
   * An existing agent of the project to use instead of creating one. Requires owning the agent or agent:authorize on it.
   */
  agentId?: string | undefined;
  /**
   * The name of the new agent. Cannot be combined with agent_id.
   */
  agentName?: string | undefined;
  /**
   * The assistant ID.
   */
  id: string;
};

/** @internal */
export type UpgradeAssistantIdentityRequestBody$Outbound = {
  agent_id?: string | undefined;
  agent_name?: string | undefined;
  id: string;
};

/** @internal */
export const UpgradeAssistantIdentityRequestBody$outboundSchema: z.ZodMiniType<
  UpgradeAssistantIdentityRequestBody$Outbound,
  UpgradeAssistantIdentityRequestBody
> = z.pipe(
  z.object({
    agentId: z.optional(z.string()),
    agentName: z.optional(z.string()),
    id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      agentId: "agent_id",
      agentName: "agent_name",
    });
  }),
);

export function upgradeAssistantIdentityRequestBodyToJSON(
  upgradeAssistantIdentityRequestBody: UpgradeAssistantIdentityRequestBody,
): string {
  return JSON.stringify(
    UpgradeAssistantIdentityRequestBody$outboundSchema.parse(
      upgradeAssistantIdentityRequestBody,
    ),
  );
}
